import { AnamneseSlideItemType, isSlideAnamneseSlide } from '@llx/common';
import { PatientCaseContent } from '@llx/common';
import { CaseMap } from '@llx/common';

export const getAnamenseItemFromCaseMap = (
  caseMap: CaseMap,
  caseID: string
): AnamneseSlideItemType | undefined => {
  if (caseMap[caseID]) {
    return getAnamneseItemFromCase(caseMap[caseID]);
  }
  return undefined;
};

export const getAnamneseItemFromCase = (
  patientCase: PatientCaseContent
): AnamneseSlideItemType | undefined => {
  const anamneseSlide = patientCase.slides.find(isSlideAnamneseSlide);

  if (!anamneseSlide) {
    return undefined;
  }
  return anamneseSlide.items[0];
};
